import { c as _c } from "react/compiler-runtime";
import { BulkChangeProjectRole } from "@components/table/members/bulk-actions/bulk-change-project-role";
import { BulkExportMembers } from "@components/table/members/bulk-actions/bulk-export-members";
import { BulkRemoveMember } from "@components/table/members/bulk-actions/bulk-remove-member";
import { BulkResendInvitation } from "@components/table/members/bulk-actions/bulk-resend-invitation";
import { BulkSendEmail } from "@components/table/members/bulk-actions/bulk-send-email";
import { useCanAssignProjectRoles } from "@hooks/feature-control/use-can-assign-project-roles";
import { useHasUserValidPermissionProjectLevel } from "@hooks/permission-control/use-has-user-valid-permission-project-level";
import { useShouldShowBulkAction } from "@hooks/table/use-should-show-bulk-action";
import { useAppSelector } from "@store/store-helper";
import { fetchingProjectsFlagsSelector } from "@store/projects/projects-selector";
import { selectedRowIdsSelector } from "@store/table/table-selector";
import { useMemo } from "react";
import { UiUtils } from "@stellar/utils";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
/** List all the bulk action components for project team table */
export function useProjectTeamBulkActions(t0) {
  const $ = _c(53);
  const {
    companyId,
    members,
    project
  } = t0;
  const selectedRowIds = useAppSelector(selectedRowIdsSelector);
  const {
    isFetchingProjects
  } = useAppSelector(fetchingProjectsFlagsSelector);
  let filteredMembers;
  let isAnyMemberPending;
  let isAnyRowSelected;
  let t1;
  if ($[0] !== members || $[1] !== selectedRowIds) {
    let t2;
    if ($[6] !== selectedRowIds) {
      t2 = member => selectedRowIds.some(identity => identity === member.identity);
      $[6] = selectedRowIds;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    filteredMembers = members.filter(t2);
    isAnyRowSelected = filteredMembers.length !== 0;
    isAnyMemberPending = filteredMembers.some(_temp);
    t1 = filteredMembers.some(_temp2);
    $[0] = members;
    $[1] = selectedRowIds;
    $[2] = filteredMembers;
    $[3] = isAnyMemberPending;
    $[4] = isAnyRowSelected;
    $[5] = t1;
  } else {
    filteredMembers = $[2];
    isAnyMemberPending = $[3];
    isAnyRowSelected = $[4];
    t1 = $[5];
  }
  const isAnyMemberTeam = t1;
  let t2;
  if ($[8] !== project) {
    t2 = {
      project
    };
    $[8] = project;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const {
    canChangeRole,
    canDeleteMemberFromProject
  } = useHasUserValidPermissionProjectLevel(t2);
  const canAssignProjectRoles = useCanAssignProjectRoles();
  let allowedButtons;
  if ($[10] !== canAssignProjectRoles || $[11] !== canChangeRole || $[12] !== canDeleteMemberFromProject || $[13] !== isAnyMemberPending || $[14] !== isAnyMemberTeam || $[15] !== isAnyRowSelected || $[16] !== project) {
    allowedButtons = ["export"];
    if (project && isAnyRowSelected) {
      if (!isAnyMemberTeam) {
        allowedButtons.push("sendEmail");
      }
      if (canChangeRole && canAssignProjectRoles) {
        allowedButtons.push("changeRole");
      }
      if (isAnyMemberPending) {
        allowedButtons.push("resendInvitation");
      }
      if (canDeleteMemberFromProject) {
        allowedButtons.push("removeMember");
      }
    }
    $[10] = canAssignProjectRoles;
    $[11] = canChangeRole;
    $[12] = canDeleteMemberFromProject;
    $[13] = isAnyMemberPending;
    $[14] = isAnyMemberTeam;
    $[15] = isAnyRowSelected;
    $[16] = project;
    $[17] = allowedButtons;
  } else {
    allowedButtons = $[17];
  }
  const allowedButtonsBasedOnRowSelection = allowedButtons;
  let t3;
  if ($[18] !== allowedButtonsBasedOnRowSelection) {
    t3 = {
      allowedButtonsBasedOnRowSelection
    };
    $[18] = allowedButtonsBasedOnRowSelection;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  const {
    shouldShowBulkButtons
  } = useShouldShowBulkAction(t3);
  let t4;
  if ($[20] !== isFetchingProjects || $[21] !== members.length || $[22] !== shouldShowBulkButtons) {
    t4 = shouldShowBulkButtons("export") && (isFetchingProjects || members.length > 0);
    $[20] = isFetchingProjects;
    $[21] = members.length;
    $[22] = shouldShowBulkButtons;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  const shouldShowExportButton = t4;
  if (!companyId || !project) {
    let t5;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {
        changeRole: null,
        seats: null,
        addToTeam: null,
        resendInvitation: null,
        removeMember: null,
        sendEmail: null,
        export: null
      };
      $[24] = t5;
    } else {
      t5 = $[24];
    }
    return t5;
  }
  let t5;
  if ($[25] !== companyId || $[26] !== project || $[27] !== shouldShowBulkButtons) {
    t5 = shouldShowBulkButtons("changeRole") ? <BulkChangeProjectRole companyId={companyId} projectId={project.id} /> : null;
    $[25] = companyId;
    $[26] = project;
    $[27] = shouldShowBulkButtons;
    $[28] = t5;
  } else {
    t5 = $[28];
  }
  let t6;
  if ($[29] !== companyId || $[30] !== filteredMembers || $[31] !== project || $[32] !== shouldShowBulkButtons) {
    t6 = shouldShowBulkButtons("resendInvitation") ? <BulkResendInvitation selectedEntities={filteredMembers} companyId={companyId} projectId={project.id} subjectType="project" /> : null;
    $[29] = companyId;
    $[30] = filteredMembers;
    $[31] = project;
    $[32] = shouldShowBulkButtons;
    $[33] = t6;
  } else {
    t6 = $[33];
  }
  let t7;
  if ($[34] !== companyId || $[35] !== project || $[36] !== shouldShowBulkButtons) {
    t7 = shouldShowBulkButtons("removeMember") ? <BulkRemoveMember subjectType="project" companyId={companyId} projectId={project.id} /> : null;
    $[34] = companyId;
    $[35] = project;
    $[36] = shouldShowBulkButtons;
    $[37] = t7;
  } else {
    t7 = $[37];
  }
  let t8;
  if ($[38] !== filteredMembers || $[39] !== shouldShowBulkButtons) {
    t8 = shouldShowBulkButtons("sendEmail") ? <BulkSendEmail selectedEntities={filteredMembers} /> : null;
    $[38] = filteredMembers;
    $[39] = shouldShowBulkButtons;
    $[40] = t8;
  } else {
    t8 = $[40];
  }
  let t9;
  if ($[41] !== filteredMembers || $[42] !== isAnyRowSelected || $[43] !== members || $[44] !== project || $[45] !== shouldShowExportButton) {
    t9 = shouldShowExportButton ? <BulkExportMembers selectedEntities={isAnyRowSelected ? filteredMembers : members} subjectType="project" entityName={project.name ?? UiUtils.DASH} areEntitiesSelected={isAnyRowSelected} /> : null;
    $[41] = filteredMembers;
    $[42] = isAnyRowSelected;
    $[43] = members;
    $[44] = project;
    $[45] = shouldShowExportButton;
    $[46] = t9;
  } else {
    t9 = $[46];
  }
  let t10;
  if ($[47] !== t5 || $[48] !== t6 || $[49] !== t7 || $[50] !== t8 || $[51] !== t9) {
    t10 = {
      changeRole: t5,
      seats: null,
      addToTeam: null,
      resendInvitation: t6,
      removeMember: t7,
      sendEmail: t8,
      export: t9
    };
    $[47] = t5;
    $[48] = t6;
    $[49] = t7;
    $[50] = t8;
    $[51] = t9;
    $[52] = t10;
  } else {
    t10 = $[52];
  }
  return t10;
}
function _temp2(member_1) {
  return FaroCoreApiUtils.Member.isTeam(member_1);
}
function _temp(member_0) {
  return !FaroCoreApiUtils.Member.isMemberActive(member_0);
}